import { render, staticRenderFns } from "./CitiesTable.vue?vue&type=template&id=28adcda0&scoped=true"
import script from "./CitiesTable.vue?vue&type=script&lang=ts"
export * from "./CitiesTable.vue?vue&type=script&lang=ts"
import style0 from "./CitiesTable.vue?vue&type=style&index=0&id=28adcda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28adcda0",
  null
  
)

export default component.exports